import { useEffect, useState } from "react";
import {
  getPacking,
  getProductClass,
  getRank,
} from "../../../http/api/MasterAPI";

const useVarData = () => {
  const [ranks, setRanks] = useState([]);
  const [productClasses, setProductClasses] = useState([]);
  const [packings, setPackings] = useState([]);

  async function GetRank() {
    try {
      let response = await getRank({});
      let listInfo = response.masterVarInfo;
      listInfo = listInfo
        .filter((o) => o.varCd != 0)
        .map((o) => ({
          rankId: o.varCd,
          rankName: o.varValue1,
        }))
        .sort((a, b) => a.rankId - b.rankId);
      setRanks(listInfo);
      console.log("等級リスト取得");
    } catch (e) {
      console.log("等級リストを取得する際にエラー発生した：", e);
    }
  }
  async function GetProductClass() {
    try {
      let response = await getProductClass({});
      let listInfo = response.masterVarInfo;
      listInfo = listInfo
        .filter((o) => o.varCd != 0)
        .map((o) => ({
          productClassId: o.varCd,
          productClassName: o.varValue1,
        }))
        .sort((a, b) => a.productClassId - b.productClassId);
      setProductClasses(listInfo);
      console.log("階級リスト取得");
    } catch (e) {
      console.log("階級リストを取得する際にエラー発生した：", e);
    }
  }
  async function GetPacking() {
    try {
      let response = await getPacking({});
      let listInfo = response.masterVarInfo;
      listInfo = listInfo
        .filter((o) => o.varCd != 0)
        .map((o) => ({
          packingId: o.varCd,
          packingName: o.varValue1,
        }))
        .sort((a, b) => a.packingId - b.packingId);
      setPackings(listInfo);
      console.log("荷姿リスト取得");
    } catch (e) {
      console.log("荷姿リストを取得する際にエラー発生した：", e);
    }
  }
  useEffect(() => {
    GetRank();
    GetProductClass();
    GetPacking();
  }, []);

  return {
    ranks,
    productClasses,
    packings,
  };
};

export default useVarData;
